App.prototype.getCart = function (props = {}) {

    const {delivery_type_id, payment_method_id, installment_amount, cb = () => {}} = props;

    const params = new URLSearchParams();

    if (delivery_type_id) {

        params.set("delivery_type_id", delivery_type_id);

    }

    if (payment_method_id) {

        params.set("payment_method_id", payment_method_id);

    }

    if (payment_method_id) {

        params.set("payment_method_id", payment_method_id);

    }

    if (installment_amount) {

        params.set("installment_amount", installment_amount);

    }

    App.prototype.toggleDisabledBasketFields(true);

    $.ajax({
        type: 'GET',
        url: App.prototype.apiAddress + 'basket' + (params ? '?' + params.toString() : ''),
        dataType: "json",
        success: function (response) {
            App.prototype.buildCart(response);

            cb();
        },
        complete: function () {

            App.prototype.toggleDisabledBasketFields(false);

        }
    });
};
